import { Button, Card, LearnMoreLink, Text } from '@ui/themed';
import { t } from 'i18next';
import type { I18nPrefix } from '../../../i18n/prefix';
import { PLATFORM_DOCS_URLS } from '../constants';

const CONFIGURATIONS_I18N =
  'features:platform.pages.platform_page.configurations' satisfies I18nPrefix;

export function ConfigurationsCard({
  onConfigureMetafields,
}: {
  onConfigureMetafields: () => void;
}) {
  return (
    <Card>
      <Card.Header headingLevel="h2">{t(`${CONFIGURATIONS_I18N}.title`)}</Card.Header>
      <Card.Body>
        <div className="flex items-start justify-between gap-4">
          <div className="flex min-w-0 flex-1 flex-col">
            <Text>{t(`${CONFIGURATIONS_I18N}.metafields.label`)}</Text>
            <Text size="sm" variant="secondary">
              {t(`${CONFIGURATIONS_I18N}.metafields.description`)}{' '}
              <LearnMoreLink link={PLATFORM_DOCS_URLS.metafields} />
            </Text>
          </div>
          <Button variant="secondary" onClick={onConfigureMetafields}>
            {t(`${CONFIGURATIONS_I18N}.configure`)}
          </Button>
        </div>
      </Card.Body>
    </Card>
  );
}
